import { MAX_USING_FEE } from '@/entities/map'

export const MAN_WON_UNIT = 10000

export const USING_FEE_VALUE_FORMAT = {
  formatValue: (value: number) =>
    value === MAX_USING_FEE
      ? `${value / MAN_WON_UNIT}+`
      : `${value / MAN_WON_UNIT}`,
  parse: (input: string) =>
    (Number(input.replace(/\D/g, '')) || 0) * MAN_WON_UNIT,
  maxLength: 4,
  unit: '만 원' as const,
  gapWhenReversed: MAN_WON_UNIT,
}

export const ENGLISH_USING_FEE_VALUE_FORMAT = {
  formatValue: (value: number) =>
    value === MAX_USING_FEE
      ? `${value.toLocaleString()}+`
      : value.toLocaleString(),
  parse: (input: string) => Number(input.replace(/\D/g, '')) || 0,
  maxLength: 7,
  unit: '₩' as const,
  gapWhenReversed: MAN_WON_UNIT,
}
